import { Pressable, View } from 'react-native';
import { Check } from 'lucide-react-native';
import { colors } from '@hogar/shared';

/** A large checkbox for picking rooms, areas, and starter tasks. */
export function Tick({ on, onPress }: { on: boolean; onPress?: () => void }) {
  const style = { width: 28, height: 28, borderRadius: 8, borderWidth: 2, borderColor: on ? colors.primary : '#CFD6D0', backgroundColor: on ? colors.primary : colors.white, alignItems: 'center', justifyContent: 'center' } as const;
  // Inside a row that is itself the button, the box is only a picture, so a tap on it reaches the row.
  if (!onPress) return <View style={style}>{on && <Check size={16} color={colors.white} strokeWidth={3} />}</View>;
  return (
    <Pressable
      onPress={onPress}
      hitSlop={10}
      style={style}
    >
      {on && <Check size={16} color={colors.white} strokeWidth={3} />}
    </Pressable>
  );
}
